import Config from "../config";
import firebase from "./firebase";

export async function fetchWithAuth(url, options) {
  const token = firebase.auth().currentUser
    ? await firebase.auth().currentUser.getIdToken()
    : "";
  const authHeaders = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  };
  const mergedHeader = Object.assign(
    authHeaders,
    options ? options.headers : {}
  );
  const mergedOptions = Object.assign({}, options, { headers: mergedHeader });
  return fetch(`${Config.firebaseFunctionURL}/admin${url}`, mergedOptions);
}



// WEBPACK FOOTER //
// ./src/lib/AdminAPI.js